

// Strip a leading www. so www.<host> resolves the same as <host>.
const normalizeHostname = (hostname: string): string => hostname.replace('www.', '');

// Okta tenant per environment. SSO (IdP-initiated) is only used in model and
// prod; dev/qa share the (inert) dev tenant, ceps mirrors the model tenant.
type OktaEnv = 'prod' | 'model' | 'ceps' | 'dev';

const OKTA_TENANTS: Record<OktaEnv, { clientId: string; issuer: string }> = {
    prod:  { clientId: '0oaqpjy02gS43glou1t7', issuer: 'https://assurant.okta.com' },
    model: { clientId: '0oa1h58jd2ote0prX0h8', issuer: 'https://idm-model.assurant.com' },
    ceps:  { clientId: '0oa1h58jd2ote0prX0h8', issuer: 'https://idm-model.assurant.com' },
    dev:   { clientId: '0oa1f9ffd38nw98Y80h8', issuer: 'https://idm-dev.assurant.com' },
};

// One decision drives both clientId and issuer so they can never be mismatched.
const resolveOktaEnv = (hostname: string): OktaEnv => {
    const host = normalizeHostname(hostname);
    // Prod SSO domains — matched exactly so prod creds never leak to an unknown host.
    if (host === 'espp.epgins.com' || host === 'ppp.cnhinsurance.com') return 'prod';
    // ceps has its own tenant (same values as model).
    if (host.includes('ceps')) return 'ceps';
    // Model + integration-model SSO domains.
    if (host.includes('model')) return 'model';
    // dev, qa, edge, localhost and anything else: dev tenant, no SSO.
    return 'dev';
};

export const oktaClientID = (hostname: string = window.location.hostname): string =>
    OKTA_TENANTS[resolveOktaEnv(hostname)].clientId;

export const oktaBaseUrl = (hostname: string = window.location.hostname): string =>
    OKTA_TENANTS[resolveOktaEnv(hostname)].issuer;


export default {
    oidc: {
        clientId: oktaClientID(),
        issuer: oktaBaseUrl(),
        redirectUri: window.location.protocol + '//' + window.location.hostname + '/sso',
        scopes: ['openid', 'email', 'profile', 'groups'],
        testing: {
            disableHttpsCheck: false
        },
    },
    widget: {
        useInteractionCodeFlow: false,
    },
    resourceServer: {
        messagesUrl: 'http://localhost:8000/api/messages',
    },

};